import React, { createContext, useState, useContext, useEffect } from "react";
import i18n from "src/i18n";

const LanguageContext = createContext({
    language: 'en',
    toggleLanguage: (lang: string) => { }
});

export const LanguageProvider = (({ children }) => {

    const getBrowserLanguage = () => {
        if (typeof navigator !== "undefined") {  // Ensure 'navigator' exists (e.g., SSR safety)
            const browserLang = navigator.language || (navigator.languages && navigator.languages[0]);
            if (browserLang) {
                return browserLang.startsWith("es") ? "es" : "en"; // Default to 'en' if not Spanish
            }
        }
        return "en"; // Fallback to English
    };

    const [language, setLanguage] = useState("en");

    useEffect(() => {
        const storedLanguage = localStorage.getItem("language");
        const initialLanguage = storedLanguage || getBrowserLanguage();
        setLanguage(initialLanguage);
        i18n.changeLanguage(initialLanguage); // Ensure i18n is synced with the stored language
        localStorage.setItem("language", initialLanguage);
    }, []);

    const toggleLanguage = (lang: string) => {
        setLanguage(lang);
        localStorage.setItem('language', lang);
        i18n.changeLanguage(lang);
    }

    return (
        <LanguageContext.Provider value={{ language, toggleLanguage }}>
            {children}
        </LanguageContext.Provider>
    )
})

export const useLanguage = () => useContext(LanguageContext);